import Cookies from "js-cookie";
import service from "../../Services/apiheader";


const prefix = '/audit/log-record';

// Get tenantId from cookies
const tenantId = Cookies.get("USER_TENANT_ID");

export const fetchAuditFieldModification = (auditId: string) => 
    service.get(`${prefix}/one/modification-info`, { params: { auditId },  headers:{"X-Tenant-Id":tenantId }} );

export const fetchOperationListByEntityId = (params: { entityId: string, moduleName: string, pageNum: number, pageSize: number }) => {
    
    return service.post(`${prefix}/entity/operation-list`, params,
        { headers:{"X-Tenant-Id":tenantId }}
    );
};

export const EXPORT_AUDIT_LOG_URL = `${prefix}/export`;

export const EXPORT_AUDIT_ENTITY_IDENTIFIER_URL = `${prefix}/export/entity/operation-list`